import List from "@/components/list";
import router from "@/router";
import store from "@/store";
import { tableBaseProps } from "@/utils/common.js";

const Table = (args) => {
  const { listeners } = args;
  const RCSelectionChange = listeners["selection-change"] || function() {};
  const manageSmallClass = listeners["manageSmallClass"] || function() {};
  const classRemark = listeners["classRemark"] || function() {};
  const cancelPublish = listeners["cancelPublish"] || function() {};
  const toSelLetterManage = listeners["toSelLetterManage"] || function() {};
  const classOrder = listeners["classOrder"] || function() {};
  const deleteClass = listeners["deleteClass"] || function() {};
  const publishClass = listeners["publishClass"] || function() {};
  const goAdmissionNotice = listeners["goAdmissionNotice"] || function() {};
  const flatPermissions = store.getters.flatPermissions;
  // 当增加按钮权限时，需在这维护按钮的权限列表
  const permissionList = [
    "offlineClass:update",
    "offlineClass:delete",
    "offlineClass:publish",
    "classOffline:pageStudent",
    "group:page",
    "offlineClass:selLetter",
    "offlineClass:smallClass",
    "enroll:reportManage",
    "offlineClass:teaching",
    "offlineClass:updateRemarks",
    "liaison:user:workerManage",
    "offlineClass:updateOrder"
  ];

  const topSelType = [16, 25]; // * 上级选调类型
  const noSmallClassType = [15, 21, 16, 25, 24];

  // 到班级详情
  function goClassDetail(offlineClass) {
    // if (flatPermissions.includes("offlineClass:detail")) {
    let query = { id: offlineClass.uuid };
    if (offlineClass.classParentId) {
      query.parentId = offlineClass.classParentId;
    }
    router.push({
      path: "offlineClass/detail",
      query: query,
    });
    // }
  }

  // 分组管理
  function goClassGroup(offlineClass) {
    router.push({
      path: "offlineClass/classGroup",
      query: {
        id: offlineClass.uuid,
        className: offlineClass.className,
        groupSourceType: offlineClass.groupSourceType || 1,
        isParty: offlineClass.isParty || 0,
        trainTypeName: offlineClass.trainTypeName,
      },
    });
  }

  // 线下班级工作人员管理
  function toMangeWorker(id) {
    router.push({ path: "/offlineClass/workerManage", query: { id } });
  }

  // 编辑班级
  function editClass({ uuid, classParentId }) {
    let query = { id: uuid };
    if (classParentId) {
      query.parentId = classParentId;
    }
    router.push({ path: "/offlineClass/add", query: query });
  }

  // 学员管理
  function studentsManage(offlineClass) {
    if (topSelType.includes(offlineClass.trainType)) {
      router.push({
        path: "offlineClass/transferStudents",
        query: {
          id: offlineClass.uuid,
        },
      });
    } else {
      router.push({
        path: "offlineClass/students",
        query: {
          id: offlineClass.uuid,
          isParty: offlineClass.isParty,
          isAttachment: offlineClass.isAttachment,
          trainTypeName: offlineClass.trainTypeName,
          classParentId: offlineClass.classParentId,
          childNum: offlineClass.childNum,
          onlineLearn: offlineClass.trainType == 24 && offlineClass.isRelevanceZwy == 1 ? 1 : 0,
          status: offlineClass.classStatus,
        },
      });
    }
  }

  // 教学管理-教学计划
  function teachingPlan(offlineClass) {
    router.push({
      path: "offlineClass/teaching",
      query: {
        id: offlineClass.uuid,
        classStatus: offlineClass.classStatus,
        className: offlineClass.className,
      },
    });
  }
  // 报到管理
  function classManage(offlineClass) {
    // 1）如果当前班级有拆分小班，则点击先进入小班列表页面; 2）如果未拆分小班，点击进入报到详情页面
    if (offlineClass.childNum > 0) {
      router.push({
        path: "offlineClass/reportSmallClass",
        query: {
          id: offlineClass.uuid,
        },
      });
    } else {
      router.push({
        path: "offlineClass/reportManage",
        query: {
          id: offlineClass.uuid,
        },
      });
    }
  }

  const Deal = ({ props: { vo } }) => {
    const offlineClass = vo.row;
    const dealConf = [
      [
        "icon-edit",
        "编辑",
        () => {
          editClass(offlineClass);
        },
        "offlineClass:update",
      ],
      [
        "icon-delete",
        "删除",
        () => {
          deleteClass(offlineClass.uuid);
        },
        "offlineClass:delete",
      ],
    ];

    if (offlineClass.publishStatus === 0) {
      dealConf.push([
        "icon_fabu",
        "发布",
        () => {
          publishClass(offlineClass);
        },
        "offlineClass:publish",
      ]);
    }

    if (
      offlineClass.publishStatus !== 0 &&
      topSelType.includes(offlineClass.trainType)
    ) {
      if (offlineClass.classStatus == 4) {
        dealConf.push([
          "iconfont ic_unpublish iconfont-adapt-disabled",
          "取消发布",
          () => {},
          "offlineClass:publish",
        ]);
      } else {
        dealConf.push([
          "iconfont ic_unpublish iconfont-adapt",
          "取消发布",
          () => cancelPublish(offlineClass),
          "offlineClass:publish",
        ]);
      }
    }

    if (!noSmallClassType.includes(offlineClass.trainType)) {
      dealConf.push([
        "ic-samll-class",
        "小班管理",
        () => {
          manageSmallClass(offlineClass);
        },
        "offlineClass:smallClass",
      ]);
    }

    if (
      offlineClass.childNum === 0 &&
      !topSelType.includes(offlineClass.trainType)
    ) {
      dealConf.push([
        "icon-class-group",
        "分组管理",
        () => {
          goClassGroup(offlineClass);
        },
        "group:page",
      ]);
    }

    if (topSelType.includes(offlineClass.trainType)) {
      dealConf.push([
        "iconfont ic_a-xuantiaohanguanli-moren2x iconfont-adapt",
        "选调函管理",
        () => toSelLetterManage(offlineClass),
        "offlineClass:selLetter",
      ]);
    }

    const isShowjxlx = ['高校专题研修班', '轮训班', '党校专题研讨班', '网院专题研习班'].includes(offlineClass.trainTypeName)

    return (
      <div class="deal-group">
        {dealConf.map((item) => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
        <el-tooltip
          content="学员管理"
          placement="top"
          v-permission="classOffline:pageStudent"
        >
          <i
            class="icon-student"
            onClick={() => studentsManage(offlineClass)}
          ></i>
        </el-tooltip>
        <el-tooltip
          content="报到管理"
          placement="top"
          v-permission="enroll:reportManage"
        >
          <i
            class="iconfont ic_checkinmanagement iconfont-adapt"
            onClick={() => classManage(offlineClass)}
          ></i>
        </el-tooltip>

        { isShowjxlx ? (
          <el-tooltip
            content="教学管理"
            placement="top"
            v-permission="offlineClass:teaching"
          >
            <i
              class="icon-teaching"
              onClick={() => teachingPlan(offlineClass)}
            ></i>
          </el-tooltip>
        ) : null}

        <el-tooltip
          content="班级备注"
          placement="top"
          v-permission="offlineClass:updateRemarks"
        >
          <i
            class="iconfont ic_a-banjibeizhu-moren2x iconfont-adapt"
            onClick={() => classRemark(offlineClass)}
          ></i>
        </el-tooltip>

        <el-tooltip
          content="工作人员管理"
          placement="top"
          v-permission="liaison:user:workerManage"
        >
          <i
            class="iconfont icgongzuorenyuanguanli iconfont-adapt"
            onClick={() => {
              toMangeWorker(offlineClass.uuid);
            }}
          ></i>
        </el-tooltip>
        <el-tooltip
          content="修改排序码"
          placement="top"
          v-permission="offlineClass:updateOrder"
        >
          <i
            class="iconfont icpaixu iconfont-adapt"
            onClick={() => classOrder(offlineClass)}
          ></i>
        </el-tooltip>
        <el-tooltip
          content="入学通知书管理"
          placement="top"
          v-permission="offlineClass:classManagePage"
        >
          <i
            class="iconfont icruxuetongzhishu_sel iconfont-adapt"
            onClick={() => goAdmissionNotice(offlineClass)}
          ></i>
        </el-tooltip>
      </div>
    );
  };

  const ClassStatusName = ({ props: { vo } }) => {
    const classStatusName = vo.row.classStatusName
      ? vo.row.classStatusName
      : "--";
    return <span>{classStatusName}</span>;
  };
  const ClassPushTime = ({ props: { vo } }) => {
    const classPushTime = vo.row.classPushTime ? vo.row.classPushTime : "--";
    return (
      <div class="table-row-column">
        <span>{vo.row.classPushStatusName}</span>
        {vo.row.classPushTime ? <span>{classPushTime}</span> : null}
      </div>
    );
  };

  const ClassName = ({ props: { vo } }) => {
    const offlineClass = vo.row;
    return (
      <div class="base-hover-char" onClick={() => goClassDetail(offlineClass)}>
        {offlineClass.className}
      </div>
    );
  };
  const EnrollTime = ({ props: { vo } }) => {
    const offlineClass = vo.row;
    return (
      <div class="table-row-column">
        <span>{offlineClass.trainStartTime}</span>
        <span>{offlineClass.trainEndTime}</span>
      </div>
    );
  };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main",
    },
    {
      ...tableBaseProps("班级名称", "className", "m200", false),
      render: (vo) => <ClassName vo={vo} />,
    },
    tableBaseProps("主办单位", "organizer", "m100"),
    tableBaseProps("班级类型", "trainTypeName", "120"),
    tableBaseProps("办班级别", "classLevelName", "100"),
    {
      ...tableBaseProps("报名情况", "enrollSituation", "110"),
      renderHeader: () => {
        return (
          <div class="table-row-column">
            <span>报名情况</span>
            <span>报名|计划(人)</span>
          </div>
        );
      },
    },
    {
      ...tableBaseProps("班级状态", "classStatusName", "80"),
      render: (vo) => <ClassStatusName vo={vo} />,
    },
    tableBaseProps("发布状态", "publishStatusName", "80"),
    {
      ...tableBaseProps("培训时间", "", "100"),
      render: (vo) => <EnrollTime vo={vo} />,
    },
    tableBaseProps("结业率", "graduationRate", "80"),
    {
      ...tableBaseProps("党校同步状态", "classPushStatusName", "150"),
      render: (vo) => <ClassPushTime vo={vo} />,
    },
  ];
  // let iconNum = 0;
  // permissionList.forEach((x) => {
  //   if (flatPermissions.includes(x)) {
  //     iconNum += 1;
  //   }
  // });
  // if (iconNum > 0) {
    AccountTableConfig.push({
      label: "操作",
      fixed: "right",
      width: 160,
      render: (vo) => <Deal vo={vo} />,
    });
  // }
  return (
    <List
      {...args}
      onSelectionChange={RCSelectionChange}
      talbeCols={AccountTableConfig}
    />
  );
};

export default Table;
